function _slicedToArray(r, e) { return _arrayWithHoles(r) || _iterableToArrayLimit(r, e) || _unsupportedIterableToArray(r, e) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }
function _iterableToArrayLimit(r, l) { var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (null != t) { var e, n, i, u, a = [], f = !0, o = !1; try { if (i = (t = t.call(r)).next, 0 === l) { if (Object(t) !== t) return; f = !1; } else for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0); } catch (r) { o = !0, n = r; } finally { try { if (!f && null != t["return"] && (u = t["return"](), Object(u) !== u)) return; } finally { if (o) throw n; } } return a; } }
function _arrayWithHoles(r) { if (Array.isArray(r)) return r; }
import React, { useState, useEffect } from "react";
import { Form, Input, Button, Descriptions, Divider, Tabs, Alert, Tag, Upload, notification } from 'antd';
import { Container, Col, Row } from "react-bootstrap";
import Common from "../includes/Common";
import { Upload as UploadIcon } from 'react-bootstrap-icons';
import SetBiochimie from "./SetBiochimie";
import SetHemato from "./SetHemato";
import SetUrine from "./SetUrine";
import SetIonogramme from "./SetIonogramme";
import SetSerologie from "./SetSerologie";
import SaveDrugData from "./SaveDrugData";
import SaveParasitologie from "./SaveParasitologie";
import SaveHemostase from "./SaveHemostase";
import SaveEcbu from "./SaveEcbu";
import SetCoproculture from "./SetCoproculture";
import SetBloodParasitology from "./SetBloodParasitology";
import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
var SaveLaboData = function SaveLaboData(_ref) {
  var candidat = _ref.candidat,
    _handler = _ref.handler;
  var _useState = useState(false),
    _useState2 = _slicedToArray(_useState, 2),
    isFormProcessing = _useState2[0],
    setIsFormProcessing = _useState2[1];
  var _useState3 = useState(''),
    _useState4 = _slicedToArray(_useState3, 2),
    errorMessage = _useState4[0],
    setErrorMessage = _useState4[1];
  var _useState5 = useState(null),
    _useState6 = _slicedToArray(_useState5, 2),
    file = _useState6[0],
    setFile = _useState6[1];
  var _Form$useForm = Form.useForm(),
    _Form$useForm2 = _slicedToArray(_Form$useForm, 1),
    form = _Form$useForm2[0];
  var props = {
    onRemove: function onRemove(file) {
      setFile(null);
    },
    beforeUpload: function beforeUpload(file) {
      setFile(file);
      return false;
    },
    accept: ".pdf",
    maxCount: 1
  };
  var tabsItem = [{
    key: 1,
    label: /*#__PURE__*/_jsx("b", {
      children: "BIOCHIMIE"
    }),
    children: /*#__PURE__*/_jsx(Container, {
      children: /*#__PURE__*/_jsx(Row, {
        children: /*#__PURE__*/_jsx(Col, {
          lg: 12,
          children: /*#__PURE__*/_jsx(SetBiochimie, {
            candidat: candidat,
            update: candidat.laboratory_result != null && candidat.laboratory_result.biochimie != null,
            handler: function handler() {
              _handler();
              notification.success({
                message: "Ok!",
                description: "Données sauvegardées !"
              });
            }
          })
        })
      })
    })
  }, {
    key: 10,
    label: /*#__PURE__*/_jsx("b", {
      children: "COPROCULTURE"
    }),
    children: /*#__PURE__*/_jsx(Container, {
      children: /*#__PURE__*/_jsx(Row, {
        children: /*#__PURE__*/_jsx(Col, {
          lg: 12,
          children: /*#__PURE__*/_jsx(SetCoproculture, {
            candidat: candidat,
            update: candidat.laboratory_result != null && candidat.laboratory_result.coproculture != null,
            handler: function handler() {
              _handler();
              notification.success({
                message: "Ok!",
                description: "Données sauvegardées !"
              });
            }
          })
        })
      })
    })
  }, {
    key: 2,
    label: /*#__PURE__*/_jsx("b", {
      children: "HEMATO"
    }),
    children: /*#__PURE__*/_jsx(Container, {
      children: /*#__PURE__*/_jsx(Row, {
        children: /*#__PURE__*/_jsx(Col, {
          lg: 12,
          children: /*#__PURE__*/_jsx(SetHemato, {
            candidat: candidat,
            update: candidat.laboratory_result != null && candidat.laboratory_result.hemato != null,
            handler: function handler() {
              _handler();
              notification.success({
                message: "Ok!",
                description: "Données sauvegardées !"
              });
            }
          })
        })
      })
    })
  }, {
    key: 3,
    label: /*#__PURE__*/_jsx("b", {
      children: "CHIMIE URINAIRE"
    }),
    children: /*#__PURE__*/_jsx(Container, {
      children: /*#__PURE__*/_jsx(Row, {
        children: /*#__PURE__*/_jsx(Col, {
          lg: 12,
          children: /*#__PURE__*/_jsx(SetUrine, {
            candidat: candidat,
            update: candidat.laboratory_result != null && candidat.laboratory_result.urine != null,
            handler: function handler() {
              _handler();
              notification.success({
                message: "Ok!",
                description: "Données sauvegardées !"
              });
            }
          })
        })
      })
    })
  }, {
    key: 4,
    label: /*#__PURE__*/_jsx("b", {
      children: "IONOGRAMME"
    }),
    children: /*#__PURE__*/_jsx(Container, {
      children: /*#__PURE__*/_jsx(Row, {
        children: /*#__PURE__*/_jsx(Col, {
          lg: 12,
          children: /*#__PURE__*/_jsx(SetIonogramme, {
            candidat: candidat,
            update: candidat.laboratory_result != null && candidat.laboratory_result.ionogramme != null,
            handler: function handler() {
              _handler();
              notification.success({
                message: "Ok!",
                description: "Données sauvegardées !"
              });
            }
          })
        })
      })
    })
  }, {
    key: 5,
    label: /*#__PURE__*/_jsx("b", {
      children: "ADDICTOLOGIE"
    }),
    children: /*#__PURE__*/_jsx(Container, {
      children: /*#__PURE__*/_jsx(Row, {
        children: /*#__PURE__*/_jsx(Col, {
          lg: 12,
          children: /*#__PURE__*/_jsx(SaveDrugData, {
            candidat: candidat,
            update: candidat.laboratory_result != null && candidat.laboratory_result.drug_test != null,
            handler: function handler() {
              _handler();
              notification.success({
                message: "Ok!",
                description: "Données sauvegardées !"
              });
            }
          })
        })
      })
    })
  }, {
    key: 6,
    label: /*#__PURE__*/_jsx("b", {
      children: "SEROLOGIE"
    }),
    children: /*#__PURE__*/_jsx(Container, {
      children: /*#__PURE__*/_jsx(Row, {
        children: /*#__PURE__*/_jsx(Col, {
          lg: 12,
          children: /*#__PURE__*/_jsx(SetSerologie, {
            candidat: candidat,
            update: candidat.laboratory_result != null && candidat.laboratory_result.serologie != null,
            handler: function handler() {
              _handler();
              notification.success({
                message: "Ok!",
                description: "Données sauvegardées !"
              });
            }
          })
        })
      })
    })
  }, {
    key: 7,
    label: /*#__PURE__*/_jsx("b", {
      children: "PARASITOLOGIE"
    }),
    children: /*#__PURE__*/_jsx(Container, {
      children: /*#__PURE__*/_jsx(Row, {
        children: /*#__PURE__*/_jsx(Col, {
          lg: 12,
          children: /*#__PURE__*/_jsx(SaveParasitologie, {
            candidat: candidat,
            update: candidat.laboratory_result != null && candidat.laboratory_result.parasitologie != null,
            handler: function handler() {
              _handler();
              notification.success({
                message: "Ok!",
                description: "Données sauvegardées !"
              });
            }
          })
        })
      })
    })
  }, {
    key: 11,
    label: /*#__PURE__*/_jsx("b", {
      children: "PARASITOLOGIE DU SANG"
    }),
    children: /*#__PURE__*/_jsx(Container, {
      children: /*#__PURE__*/_jsx(Row, {
        children: /*#__PURE__*/_jsx(Col, {
          lg: 12,
          children: /*#__PURE__*/_jsx(SetBloodParasitology, {
            candidat: candidat,
            update: candidat.laboratory_result != null && candidat.laboratory_result.blood_parasitology != null,
            handler: function handler() {
              _handler();
              notification.success({
                message: "Ok!",
                description: "Données sauvegardées !"
              });
            }
          })
        })
      })
    })
  }, {
    key: 8,
    label: /*#__PURE__*/_jsx("b", {
      children: "HEMOSTASE"
    }),
    children: /*#__PURE__*/_jsx(Container, {
      children: /*#__PURE__*/_jsx(Row, {
        children: /*#__PURE__*/_jsx(Col, {
          lg: 12,
          children: /*#__PURE__*/_jsx(SaveHemostase, {
            candidat: candidat,
            update: candidat.laboratory_result != null && candidat.laboratory_result.hemostase != null,
            handler: function handler() {
              _handler();
              notification.success({
                message: "Ok!",
                description: "Données sauvegardées !"
              });
            }
          })
        })
      })
    })
  }, {
    key: 9,
    label: /*#__PURE__*/_jsx("b", {
      children: "ECBU"
    }),
    children: /*#__PURE__*/_jsx(Container, {
      children: /*#__PURE__*/_jsx(Row, {
        children: /*#__PURE__*/_jsx(Col, {
          lg: 12,
          children: /*#__PURE__*/_jsx(SaveEcbu, {
            candidat: candidat,
            update: candidat.laboratory_result != null && candidat.laboratory_result.ecbu != null,
            handler: function handler() {
              _handler();
              notification.success({
                message: "Ok!",
                description: "Données sauvegardées !"
              });
            }
          })
        })
      })
    })
  }];
  var onFinish = function onFinish(values) {
    setErrorMessage('');
    setIsFormProcessing(true);
    var formData = new FormData();
    formData.append("user_id", Common.currentUser.id);
    formData.append("customer_id", candidat.id);
    formData.append("comment", values.comment);
    formData.append("attached_file", file);
    axios.post(Common.baseApiUrl + "setlabodata", formData).then(function (response) {
      if (response.data.status == 200) {
        _handler();
      } else {
        setErrorMessage(response.data.message);
      }
    })["catch"](function (error) {
      setErrorMessage("Une erreur est survenue");
    })["finally"](function () {
      setIsFormProcessing(false);
    });
  };
  useEffect(function () {
    form.setFieldsValue({
      comment: ""
    });
  }, []);
  return /*#__PURE__*/_jsxs(_Fragment, {
    children: [/*#__PURE__*/_jsxs("div", {
      style: {
        padding: "20px",
        background: "#E82E44",
        borderRadius: "0px 7px 7px 7px",
        color: "#FFFFFF"
      },
      children: ["Sauvegarder les donn\xE9s de laboratoire pour le candidat ", /*#__PURE__*/_jsx("b", {
        children: candidat.name
      })]
    }), /*#__PURE__*/_jsx("br", {}), /*#__PURE__*/_jsx(Tabs, {
      items: tabsItem,
      animated: true
    })]
  });
};
export default SaveLaboData;